// eslint:disable max-func-body-length
import { Reducer } from 'redux';
import { IndicatorFactorsItemState } from './types-store';
import {
  ACTION,
  RequestCodeItem, ReceiveCodeItem, FailCodeItem,
  RequestSaveCodetableItem, ReceiveSaveCodetableItem, FailSaveCodetableItem,
  RequestCodeItemDelete, ReceiveCodeItemDelete, FailCodeItemDelete,
  CreateCodeItem,
  UpdateValidation, ResetValidation,
  ClearValidation,
  ClearCodetableOptions,
  UpdateByKey
} from './action-types';
import { codetableOptionsReducer } from '../common';

export const INITIAL_CODETABLE_ITEM_STATE: IndicatorFactorsItemState = {
  fetchingCodetableId: undefined,
  fetchingCodeId: undefined,
  fetchingCodeAccessCodes: false,
  fetchingCreateOptions: false,
  fetchingDelete: false,
  savingCodetableItem: false,
  originalCodeItem: undefined,
  codeItem: undefined,
  codetableOptions: {},
  validation: {}
};

const itemReducers: { [indexer: string]: Reducer<IndicatorFactorsItemState> } = {

  ...codetableOptionsReducer as { [indexer: string]: Reducer<IndicatorFactorsItemState> },

  [ACTION.REQUEST_CODE_ITEM]: (state: IndicatorFactorsItemState, action: RequestCodeItem): IndicatorFactorsItemState => {

    return {
      ...state,
      fetchingCodetableId: action.codetableId,
      fetchingCodeId: action.codeId
    };
  },

  [ACTION.RECEIVE_CODE_ITEM]: (state: IndicatorFactorsItemState, action: ReceiveCodeItem): IndicatorFactorsItemState => {

    const { payload: { codeId, codeItem, codetableId } } = action;

    return codetableId === state.fetchingCodetableId && codeId === state.fetchingCodeId
      ? {
        ...state,
        fetchingCodetableId: undefined,
        fetchingCodeId: undefined,
        codeItem,
        originalCodeItem: codeItem
      }
      : state;
  },

  [ACTION.FAIL_CODE_ITEM]: (state: IndicatorFactorsItemState, action: FailCodeItem): IndicatorFactorsItemState => {

    return action.codetableId === state.fetchingCodetableId && action.codeId === state.fetchingCodeId
      ? {
        ...state,
        fetchingCodetableId: undefined,
        fetchingCodeId: undefined
      }
      : state;
  },

  [ACTION.CREATE_CODE_ITEM]: (state: IndicatorFactorsItemState, action: CreateCodeItem): IndicatorFactorsItemState => {

    return {
      ...state,
      fetchingCreateOptions: false,
      codeItem: action.codeItem,
      originalCodeItem: action.codeItem
    };
  },

  [ACTION.REQUEST_CODE_ITEM_DELETE]: (state: IndicatorFactorsItemState,
    action: RequestCodeItemDelete): IndicatorFactorsItemState => {
    return {
      ...state,
      fetchingDelete: true
    };
  },

  [ACTION.RECEIVE_CODE_ITEM_DELETE]: (state: IndicatorFactorsItemState,
    action: ReceiveCodeItemDelete): IndicatorFactorsItemState => {
    return {
      ...state,
      fetchingDelete: false
    };
  },

  [ACTION.FAIL_CODE_ITEM_DELETE]: (state: IndicatorFactorsItemState, action: FailCodeItemDelete): IndicatorFactorsItemState => {
    return {
      ...state,
      fetchingDelete: false
    };
  },

  [ACTION.REQUEST_SAVE_CODETABLE_ITEM]: (state: IndicatorFactorsItemState, action: RequestSaveCodetableItem): IndicatorFactorsItemState => {
    return {
      ...state,
      savingCodetableItem: true
    };
  },

  [ACTION.RECEIVE_SAVE_CODETABLE_ITEM]: (state: IndicatorFactorsItemState, action: ReceiveSaveCodetableItem): IndicatorFactorsItemState => {
    return {
      ...state,
      savingCodetableItem: false,
      originalCodeItem: state.codeItem
    };
  },

  [ACTION.FAIL_SAVE_CODETABLE_ITEM]: (state: IndicatorFactorsItemState, action: FailSaveCodetableItem): IndicatorFactorsItemState => {
    return {
      ...state,
      savingCodetableItem: false
    };
  },

  [ACTION.UPDATE_VALIDATION]: (state: IndicatorFactorsItemState, action: UpdateValidation): IndicatorFactorsItemState => {
    return {
      ...state,
      validation: action.validation
    };
  },

  [ACTION.RESET_VALIDATION]: (state: IndicatorFactorsItemState, action: ResetValidation): IndicatorFactorsItemState => {
    const validation = { ...state.validation, [action.key]: undefined };

    return {
      ...state,
      validation
    };
  },

  [ACTION.CLEAR_VALIDATION]: (state: IndicatorFactorsItemState, action: ClearValidation): IndicatorFactorsItemState => {
    return {
      ...state,
      validation: {}
    };
  },

  [ACTION.CLEAR_CODETABLE_OPTIONS]: (state: IndicatorFactorsItemState, action: ClearCodetableOptions): IndicatorFactorsItemState => {

    return {
      ...state,
      codetableOptions: {}
    };
  },

  [ACTION.UPDATE_BY_KEY]: (state: IndicatorFactorsItemState, action: UpdateByKey): IndicatorFactorsItemState => {
    return {
      ...state,
      codeItem: {
        ...state.codeItem,
        [action.key]: action.value
      }
    };
  }
};

export const itemReducer: Reducer<IndicatorFactorsItemState> =
  (state: IndicatorFactorsItemState = INITIAL_CODETABLE_ITEM_STATE, action: any) => {
    const r = itemReducers[action.type];
    return (r && r(state, action)) || state;
  };
